module.exports = __webpack_public_path__ + "static/img/lj_02.510e81e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lj_02.jpg
// module id = d07J
// module chunks = 1